<template>
	<ol style="list-style-type:lower-alpha;">
		<slot mdc-unwrap="ul" />
	</ol>
</template>
